module.exports = __webpack_public_path__ + "img/pr24.b45023fa.png";